/**
 * Keycloak Configuration
 *
 * Configuration for Keycloak authentication service.
 * Uses environment variables for deployment flexibility.
 */

const KEYCLOAK_CONFIG = {
  // Keycloak server URL
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',

  // Realm name
  realm: process.env.KC_REALM || 'fire-defense',

  // Client ID for the fire-web-app
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'fire-web-app',
};

export default KEYCLOAK_CONFIG;
